require("./accountsBoxBody.scss");

// @vendors
const React = require("react");
const { withRouter } = require('react-router-dom');
const PropTypes = require("prop-types");

// @core
const { formatText, FormattedText, getLanguage } = require("core/i18n").i18n;

// @utilities
const {
    contactCenterClassName,
} = require("utilities/conditionals/conditionalClassname");
const { recordLink } = require("utilities/tagging");

// @commons
const { LastMovementsTable } = require("commonsComponents/lastMovementsTable");
const { OKTableRow } = require("commonsComponents/OKTableRow");
const { OKTableCell } = require("commonsComponents/OKTableCell");
const { EmptyState } = require("commonsComponents/emptyState");
const { OKLink } = require("commonsComponents/OKLink");
const { LoadingSection } = require("commonsComponents/loadingSection");

// @ components
const AccountIntervenersTooltip = require("components/contactCenter/accountIntervenersTooltip/accountIntervenersTooltip");
const AccountLastMovementsTableRow = require("components/accounts/accountLastMovements/accountLastMovementsTableRow/accountLastMovementsTableRow");
const ContactCenterRender = require("components/conditionalRender/contactCenterRender");
const OKTooltip = require("components/commons/OKTooltip/OKTooltip");
const Sca = require("components/sca/sca");
const {
    CategoriesModal,
} = require("components/commons/categoriesModal/categoriesModal");
const {
    CategoriesModalOld,
} = require("components/commons/categoriesModal/categoriesModalOld");
const { OKButton } = require("components/commons/OKButton/OKButton");
import FeatureTogglingRender from "components/conditionalRender/featureTogglingRender";

// @ constants
const {
    LAVANDA,
    PFM,
    PFM_NEW_FEATURES,
} = require("constants/flagBasedFeatures");
const {
    LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY,
} = require("constants/commonsComponents");
const {
    ACCOUNT_DEFERRABLE_PAYMENT,
    ACCOUNT_EXPANDED_TRANSACTIONS_LIMIT,
} = require("constants/index");
const {
    ACTION_EVENT_VIEW,
    DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT,
    SEE_DETAILS_ACCOUNT_ACTION_EVENT,
    SEE_DETAILS_EVENT_TAG,
} = require("constants/tagging");

const language = getLanguage();

class AccountsBoxBody extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            scaRequestModalVisible: false,
        };

        this.buildConectionError = this.buildConectionError.bind(this);
        this.buildEmptyState = this.buildEmptyState.bind(this);
        this.buildMovements = this.buildMovements.bind(this);
        this.buildScaSection = this.buildScaSection.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleToggleScaRequestModal =
            this.handleToggleScaRequestModal.bind(this);
        this.handlePostRequest = this.handlePostRequest.bind(this);
    }

    componentDidMount() {
        this.getTransactions();
        if (__CONTACT_CENTER__) {
            const { requestAccountInterveners, immAccount } = this.props;
            const accountId = immAccount.get("accountId");
            requestAccountInterveners(accountId);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { flagBasedFeatures, immAccount, immAccountsTransactions } =
            this.props;
        const { immAccountsTransactions: nextImmAccountsTransactions } =
            nextProps;

        const accountId = immAccount.get("accountId");
        const immAccountTransactions = immAccountsTransactions.get(accountId);
        const nextImmAccountTransactions =
            nextImmAccountsTransactions.get(accountId);

        if (immAccountTransactions !== nextImmAccountTransactions) {
            const immTransactionsByOrder =
                nextImmAccountTransactions.get("byOrder");
            const immTransactionsById = nextImmAccountTransactions.get("byId");
            const size = immTransactionsByOrder.size;
            const transactionsCount =
                size > ACCOUNT_EXPANDED_TRANSACTIONS_LIMIT
                    ? ACCOUNT_EXPANDED_TRANSACTIONS_LIMIT
                    : size;
            let immTransactions;

            immTransactions = immTransactionsByOrder
                .take(transactionsCount)
                .map((transactionId) => immTransactionsById.get(transactionId));

            const atLeastOneDeferralPayment = immTransactions.some(
                (transaction) =>
                    transaction.get("finance") === ACCOUNT_DEFERRABLE_PAYMENT
            );
            flagBasedFeatures.get(LAVANDA) &&
                atLeastOneDeferralPayment &&
                recordLink(
                    window.utag_last_name,
                    DEFERRAL_PAYMENT_ACCOUNT_ACTION_EVENT,
                    ACTION_EVENT_VIEW
                );
        }
    }

    getTransactions() {
        const { requestAccountTransactions, immAccount } = this.props;
        const accountId = immAccount.get("accountId");
        requestAccountTransactions(accountId);
    }

    handleRetry() {
        this.getTransactions();
    }

    handleToggleScaRequestModal() {
        const { scaRequestModalVisible } = this.state;
        this.setState({ scaRequestModalVisible: !scaRequestModalVisible });
    }

    handlePostRequest() {
        const { history, immAccount } = this.props;
        const accountId = immAccount.get("accountId");
        const link = history.push(
            "/myprofile/accounts/" + accountId + "/movements"
        );
        history.push(link);
    }

    buildConectionError() {
        const lostConnectionFirstLine = formatText(
            "myMoneyTransactions-lostConnectionFirstLine"
        );
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="myMoneyTransactions-retry" />
            </OKButton>
        );
        return (
            <div className="accounts-box-body__movements">
                <EmptyState
                    primaryText={lostConnectionFirstLine}
                    button={retryButton}
                    iconType="nointernet-banking"
                />
            </div>
        );
    }

    buildEmptyState() {
        const primaryText = formatText("myMoneyTransactions-emptyState");
        return (
            <div className="accounts-box-body__movements">
                <EmptyState
                    primaryText={primaryText}
                    iconType="search-banking"
                />
            </div>
        );
    }

    buildIntervenersList(immAccount) {
        const accountId = immAccount.get("accountId");
        const immInterveners = immAccount.get("interveners");
        return (
            <AccountIntervenersTooltip
                className="accounts-box-body__interveners-body"
                immInterveners={immInterveners}
                accountId={accountId}
            />
        );
    }

    buildScaSection(
        immProfile,
        immAccountTransactions,
        validateAndExecuteSagas
    ) {
        return (
            <Sca
                isPreview
                onHandlePostRequest={this.handlePostRequest}
                immProfile={immProfile}
                immTransactions={immAccountTransactions}
                validateAndExecuteSagas={validateAndExecuteSagas}
            />
        );
    }

    buildMovements(immAccountTransactions, immAccount) {
        const { flagBasedFeatures, index } = this.props;
        const accountId = immAccount.get("accountId");
        const immTransactionsByOrder = immAccountTransactions.get("byOrder");
        const immTransactionsById = immAccountTransactions.get("byId");
        const size = immTransactionsByOrder.size;
        const transactionsCount =
            size > ACCOUNT_EXPANDED_TRANSACTIONS_LIMIT
                ? ACCOUNT_EXPANDED_TRANSACTIONS_LIMIT
                : size;
        const labelToDetails = formatText("accounts-toDetails");

        // Don't remove the span tag, it fix a bug with the tooltip
        const categoryFormattedText = (
            <span>
                <FormattedText
                    value="myMoneyTransactions-category"
                    format="firstUppercase"
                />
            </span>
        );
        const dateFormattedText = (
            <span>
                <FormattedText
                    value="myMoneyTransactions-date"
                    format="firstUppercase"
                />
            </span>
        );

        const accountsBoxBodyClassName = contactCenterClassName(
            "accounts-box-body__movements-table"
        );
        const accountsBoxBodyCellCategoryClassName = contactCenterClassName(
            "accounts-box-body__cell-category",
            "text-center"
        );
        let response;

        if (immTransactionsByOrder.size > 0) {
            response = (
                <div className="accounts-box-body__movements">
                    {flagBasedFeatures.get(PFM_NEW_FEATURES) ? (
                        <CategoriesModal />
                    ) : (
                        <CategoriesModalOld byCategory />
                    )}
                    <LastMovementsTable
                        className={accountsBoxBodyClassName}
                        isExpandable={false}
                        groupByDate={false}
                        rowComponent={AccountLastMovementsTableRow}
                        immTransactionsByOrder={immTransactionsByOrder.take(
                            transactionsCount
                        )}
                        immTransactionsById={immTransactionsById}
                        columnsCount={
                            flagBasedFeatures.get("account-revolving", false)
                                ? 6
                                : 5
                        }
                        id={"account-box-body-last-movements"}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={language}
                    >
                        <thead>
                            <OKTableRow asHeader>
                                <OKTableCell asHeader>
                                    <OKTooltip
                                        content="accounts-dateTooltip"
                                        offset={[0, -15]}
                                        target={dateFormattedText}
                                        type="descriptive"
                                    />
                                </OKTableCell>
                                <FeatureTogglingRender
                                    notAllowedProductKey={PFM}
                                >
                                    <OKTableCell
                                        asHeader
                                        className={
                                            accountsBoxBodyCellCategoryClassName
                                        }
                                    >
                                        <OKTooltip
                                            content="myMoneyTransactions-categoryTooltip"
                                            offset={[0, -15]}
                                            target={categoryFormattedText}
                                            type="descriptive"
                                        />
                                    </OKTableCell>
                                </FeatureTogglingRender>
                                <OKTableCell asHeader={true}>
                                    <FormattedText
                                        value="myMoneyTransactions-description"
                                        format="firstUppercase"
                                    />
                                </OKTableCell>
                                {flagBasedFeatures.get(
                                    "account-revolving",
                                    false
                                ) && <OKTableCell asHeader />}
                                <OKTableCell
                                    asHeader
                                    className="accounts-box-body__movements-header-second"
                                >
                                    <FormattedText
                                        value="myMoneyTransactions-amount"
                                        format="firstUppercase"
                                    />
                                </OKTableCell>
                                <OKTableCell
                                    asHeader
                                    className="accounts-box-body__movements-header-second"
                                >
                                    <FormattedText
                                        value="myMoneyTransactions-balance"
                                        format="firstUppercase"
                                    />
                                </OKTableCell>
                            </OKTableRow>
                        </thead>
                    </LastMovementsTable>
                    <div className="accounts-box-body__link-container">
                        <OKLink
                            inverse={!__CONTACT_CENTER__}
                            modifier="complementary"
                            id={"btnAccountDetails" + index}
                            onClick={() =>
                                flagBasedFeatures.get(LAVANDA) &&
                                recordLink(
                                    window.utag_last_name,
                                    SEE_DETAILS_ACCOUNT_ACTION_EVENT,
                                    SEE_DETAILS_EVENT_TAG
                                )
                            }
                            to={
                                "/myprofile/accounts/" +
                                accountId +
                                "/movements"
                            }
                        >
                            {labelToDetails}
                        </OKLink>
                    </div>
                </div>
            );
        }

        return response;
    }

    buildInterveners(immAccount) {
        const intervenersIcon = (
            <div>
                <i className="icon-s-beneficiarios accounts-box-body__icon-beneficiaries"></i>
                <span className="accounts-box-body__text-beneficiaries">
                    <b>
                        {formatText("accountDetails-interveners").toUpperCase()}
                    </b>
                </span>
            </div>
        );

        return (
            <div className="accounts-box-body__tooltip-container">
                <OKTooltip
                    target={intervenersIcon}
                    content={this.buildIntervenersList(immAccount)}
                />
            </div>
        );
    }

    render() {
        const {
            immAccount,
            immAccountsTransactions,
            immProfile,
            index,
            validateAndExecuteSagas,
        } = this.props;

        const accountId = immAccount.get("accountId");
        const immAccountTransactions = immAccountsTransactions.get(accountId);

        const loading =
            !immAccountTransactions || immAccountTransactions.get("loading");
        const error =
            immAccountTransactions && immAccountTransactions.get("error");
        const empty =
            immAccountTransactions &&
            immAccountTransactions.get("byOrder").size === 0;
        const scaRequired =
            immAccountTransactions &&
            immAccountTransactions.get("scaRequiredAccountModal");

        let content;

        // Content
        if (loading) {
            content = <LoadingSection />;
        } else if (error) {
            content = this.buildConectionError();
        } else if (scaRequired) {
            if (immAccountTransactions.get("byId").size === 0) {
                content = this.buildScaSection(
                    immProfile,
                    immAccountTransactions,
                    validateAndExecuteSagas
                );
            } else {
                content = this.buildMovements(
                    immAccountTransactions,
                    immAccount
                );
            }
        } else if (empty) {
            content = this.buildEmptyState();
        } else {
            content = this.buildMovements(immAccountTransactions, immAccount);
        }

        // Interveners
        const interveners =
            __CONTACT_CENTER__ && !loading
                ? this.buildInterveners(immAccount)
                : null;

        return (
            <div className="accounts-box-body" id={"account-box-body" + index}>
                {content}
                <ContactCenterRender>{interveners}</ContactCenterRender>
            </div>
        );
    }
}

AccountsBoxBody.propTypes = {
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object,
    immAccountsTransactions: PropTypes.object,
    immInterveners: PropTypes.object,
    immProfile: PropTypes.object,
    index: PropTypes.number,
    requestAccountInterveners: PropTypes.func,
    requestAccountTransactions: PropTypes.func,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports = withRouter(AccountsBoxBody);
